export const BirthStonesArray = [
	{
		id: 1,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903484/BirthStone/1_mdhsfy.webp",
		month: "January",
		Name: "Garnet",
		description:
			'Garnet is the birthstone for those that are born on the month of January. The word Garnet derives from the 14th century where "gernet" meant a deep red color. In addition, it is derived from the Latin word granatum, which means seed in this instance the seed of a pomegranate.'
	},
	{
		id: 2,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903484/BirthStone/2_vr6k83.webp",
		month: "February",
		Name: "Amethyst",
		description:
			"Amethyst is purple quartz and is a beautiful blend of violet and red that can be found in every corner of the world. The name comes from the Ancient Greek, derived from the word methustos, which means “intoxicated.” Ancient wearers believed the gemstone could protect them from drunkenness."
	},
	{
		id: 3,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903484/BirthStone/3_kpimne.webp",
		month: "March",
		Name: "aquamarine",
		description:
			"The serenely colored aquamarine invokes the tranquility of its namesake, the sea. In fact, the name aquamarine is derived from the Latin word aqua, meaning water, and marina, meaning the sea.Aquamarine is a pale-blue to light-green variety of beryl. Greenish-blue aquamarine can be changed to pure-blue by heat. "
	},
	{
		id: 4,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903484/BirthStone/4_ur4r58.webp",
		month: "April",
		Name: "Diamond",
		description:
			"The diamond is the traditional birthstone of April and holds significant meaning for those born in that month"
	},
	{
		id: 5,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903484/BirthStone/5_tm3nzd.webp",
		month: "May",
		Name: "Emerald",
		description:
			"Emerald. As the birthstone for May, the emerald, a symbol of rebirth, is believed to grant the owner foresight, good fortune, and youth."
	},
	{
		id: 6,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903484/BirthStone/6_vi160x.webp",
		month: "June",
		Name: "Moonstone",
		description:
			"Moonstone is a sodium potassium aluminium silicate of the feldspar group that displays a pearly and opalescent schiller. An alternative name is hecatolite."
	},
	{
		id: 7,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903485/BirthStone/7_isuec8.webp",
		month: "July",
		Name: "Ruby",
		description:
			"Ruby is a variety of corundum which is then colored to a deep red coloring by chromium. One of the other variations of corundum is sapphire dependent on the impurities within the mineral. The name of ruby comes from the Latin word for red, rubeus"
	},
	{
		id: 8,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903485/BirthStone/8_uetrkq.webp",
		month: "August",
		Name: "Peridot",
		description:
			"Peridot occurs in silica-deficient rocks such as volcanic basalt and pallasitic meteorites. Peridot is one of only two gems observed to be formed not in the Earth’s crust, but in molten rock of the upper mantle. Gem-quality peridot is rare to find on Earth's surface due to its susceptibility to weathering during transportation from deep within the mantle to the surface."
	},
	{
		id: 9,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903485/BirthStone/9_fwscnk.webp",
		month: "September",
		Name: "Sapphire",
		description:
			"If you were born in September your birthstone is the sapphire. Similar to a ruby, a sapphire is a variety of corundum that adorns a deep blue color. The name sapphire comes from the Latin word for blue stone, sapphirus"
	},
	{
		id: 10,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903485/BirthStone/10_ph3wev.webp",
		month: "October",
		Name: "Tourmaline",
		description:
			"The name “tourmaline” comes from the Sinhalese words tura mali, which mean “stone of mixed colors.” As its name implies, tourmaline stands apart from other gemstones with its broad spectrum of colors in every shade of the rainbow."
	},
	{
		id: 11,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903485/BirthStone/11_lmqzfy.webp",
		month: "November",
		Name: "topaz",
		description:
			"Those with November birthdays have two beautiful birthstones to choose from: topaz and citrine. Topaz comes in a rainbow of colors; citrine is prized for its charming yellow and orange hues"
	},
	{
		id: 12,
		Stone: "https://res.cloudinary.com/ggi/image/upload/v1637903485/BirthStone/12_sxkzsq.webp",
		month: "December",
		Name: "Turquoise",
		description:
			"Admired since ancient times, turquoise is known for its distinct color, which ranges from powdery blue to greenish robin egg blue. It’s one of few minerals to lend its name to anything that resembles its striking color."
	}
];
